import React, { useState, useEffect } from 'react'
import { Form, Message, Table, IconButton, Icon } from 'rsuite'
import { useForm } from 'react-hook-form'
import { initialNewData, getExpandedId, getNewDataEdit } from './QualificationResponsinatorUtils'
import './styles.less'
import EditTextCell from '../../components/cell/EditTextCell'
import EditDateCell from '../../components/cell/EditDateCell'
import EditNumberCell from '../../components/cell/EditNumberCell'
import { isEmpty } from 'lodash-es'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import {
  getResponsinator,
  updateResponsinator,
  saveResponsinator,
  deleteResponsinator,
} from '../../redux/actions/proposalResponsinator'
import { startLoading, doneLoading } from '../../utils/loading'
import moment from 'moment'
import ConfirmWidget from '../confirm/ConfirmWidget'
import notification from '../../utils/notification'

export default function QualificationResponsinatorTable({ schema: _schema, ...prop }) {
  const { register, handleSubmit, errors, control, setError, clearErrors } = useForm()
  const { Column, HeaderCell, Cell, Pagination } = Table
  const [schema, setSchema] = useState(_schema)
  const [tableData, setTableData] = useState()
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [errorMsg, setErrorMsg] = useState()
  const [disabledButton, setDisabledButton] = useState(false)
  const [requestDeleteData, setRequestDeleteData] = useState()
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const styleHeaderCell = {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    lineHeight: '20px',
    paddingTop: 8,
    paddingBottom: 8,
  }

  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    if (schema?.values) {
      setTableData(schema.values)
      setDisabledButton(false)
    }
  }, [_schema])

  const handleOnClickAddNewData = async () => {
    const updateSchema = await handleCallSchema()

    let dataWithoutTotal = []
    // if (!isEmpty(tableData)) {
    //   dataWithoutTotal = tableData
    // }
    if (!isEmpty(updateSchema)) {
      dataWithoutTotal = updateSchema.values
    }

    const addedData = initialNewData(dataWithoutTotal)
    // const addedData = initialNewData([])
    setDisabledButton(true)
    setTableData((state) => {
      const dataWithoutTotal = state
      return [...dataWithoutTotal, addedData]
    })
    const newIds = getExpandedId([addedData])
    setExpandedRowKeys((state) => [...state, ...newIds])
  }

  const handleOpenEditRow = (rowData) => {
    console.log('handleOpenEditRow ', rowData)
    const nextData = getNewDataEdit(tableData, rowData)
    setTableData(nextData)
  }

  const checkResponsiblePercentBeforeSave = (valuePercentAdd, rowData) => {
    let sumResponsiblePercent = parseInt(valuePercentAdd)
    if (tableData?.length > 0) {
      tableData.map((item) => {
        if (rowData.id != item.id) {
          sumResponsiblePercent = sumResponsiblePercent + item.responsiblePercent
        }
      })
    }

    return sumResponsiblePercent <= 100 ? true : false
  }

  const handleSaveData = (data, rowData) => {
    const valuePercentAdd =
      data[`responsiblePercent_${rowData.id}`] || data[`responsiblePercent_${rowData.makeId}`]
    const check = checkResponsiblePercentBeforeSave(valuePercentAdd, rowData)

    if (check) {
      const id = rowData.makeId || rowData.id
      const date = data[`projectEndDate_${id}`] || rowData.projectEndDate
      const typeName = rowData.organizationTypeName ? rowData.organizationTypeName : 2

      let request = {
        id: rowData.id,
        projectVersionId: projectId,
        // userId: 'string',
        organizationTypeName: typeName,
        organizatioName: typeName === 1 ? 'หน่วยงานสสส.' : 'หน่วยงานอื่น ๆ',
        organizationNameOther: data[`organizationNameOther_${id}`] || '',
        projectCode: data[`projectCode_${id}`] || rowData.projectCode,
        projectName: data[`projectName_${id}`] || rowData.projectName,
        projectEndDate: moment(date).format('DD/MM/YYYY'),
        responsiblePercent: data[`responsiblePercent_${id}`],
        isDeletable: rowData.isDeletable ? rowData.isDeletable : true,
      }

      handleCallService(request)
    } else {
      notification.open('error', {
        title: 'ไม่สามารถบันทึกข้อมูลได้',
        description: '(ผลรวมทั้งหมดของปริมาณงานที่รับผิดชอบคิดเป็นสัดส่วนร้อยละ เกิน 100)',
        duration: 8000,
      })
    }
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()
    try {
      let response

      if (request.id) {
        console.log('call update.')
        response = await updateResponsinator(projectId, request)
      } else {
        console.log('call save.')
        response = await saveResponsinator(projectId, request)
      }

      const updateSchema = await handleCallSchema()
      if (updateSchema) {
        setDisabledButton(false)
        setTableData(updateSchema.values)
      }
    } catch (error) {
      console.log('error', error)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCancel = async (rowData) => {
    console.log('handleCancel ', rowData)
    // if (!rowData) {
    //   setDisabledButton(false)
    //   return setTableData((state) => [...state.slice(0, -1)])
    // }
    const nextData = getNewDataEdit(tableData, rowData)
    setTableData(nextData)
  }

  const handleDelete = (rowData) => {
    console.log('handleDelete ', rowData)
    if (!rowData.id) {
      setDisabledButton(false)
      return setTableData((state) => [...state.slice(0, -1)])
    }
    setIsShowConfirmDelete(true)
    setRequestDeleteData(rowData)
  }

  const handleOnConfirmDelete = () => {
    setIsShowConfirmDelete(false)
    handleCallApiDeleteCost(requestDeleteData)
  }

  const handleCallApiDeleteCost = async (rowData) => {
    console.log('handleCallApiDeleteCost ', rowData)
    if (rowData.isDeletable) {
      startLoading()
      setIsLoading(true)
      setIsError()
      try {
        const status = await deleteResponsinator(projectId, rowData.id)

        if (status === 200) {
          const updateSchema = await handleCallSchema()
          if (updateSchema) {
            setTableData(updateSchema.values)
          }
        } else {
          setIsDeleteError(true)
        }
      } catch (error) {
        console.log('error', error)
        setIsError(true)
      }
      setIsLoading(false)
      doneLoading()
    }
  }

  const handleCallSchema = async () => {
    try {
      const response = await getResponsinator(projectId)

      return response
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      {errorMsg && (
        <Message
          showIcon
          type={errorMsg.type}
          description={errorMsg.description}
          style={{ marginBottom: 20 }}
        />
      )}
      <Form>
        <Table
          headerHeight={fs <= 14 ? 80 : fs <= 16 ? 90 : fs <= 18 ? 95 : 100}
          expandedRowKeys={expandedRowKeys}
          rowKey="id"
          autoHeight
          height={420}
          data={tableData}
          rowHeight={(rowData) => (rowData ? 64 : 210)}
        >
          <Column align="center" width={80} fixed>
            <HeaderCell align="center" style={styleHeaderCell}>
              ลำดับ
            </HeaderCell>
            <Cell>
              {(rowData, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={300}>
            <HeaderCell align="center" style={styleHeaderCell}>
              ชื่อหน่วยงานให้ทุน สสส./อื่น ๆ (โปรดระบุ)
            </HeaderCell>
            <Cell>
              {(rowData) => {
                if (!rowData.isDeletable) {
                  return 'หน่วยงานสสส.'
                }
                return (
                  <EditTextCell
                    id={`${schema.organizationNameOther.name}_${rowData.id || rowData.makeId}`}
                    rowData={rowData}
                    rowSchema={schema.organizationNameOther}
                    dataKey={schema.organizationNameOther.name}
                    register={register}
                    control={control}
                    errors={errors}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={340} minWidth={340} flexGrow={1}>
            <HeaderCell align="center" style={styleHeaderCell}>
              ชื่อโครงการ (ที่อยู่ระหว่างดำเนินการ)
            </HeaderCell>
            <Cell>
              {(rowData) => {
                if (!rowData.isDeletable) {
                  return rowData.projectName
                }
                return (
                  <EditTextCell
                    id={`${schema.projectName.name}_${rowData.id || rowData.makeId}`}
                    rowData={rowData}
                    rowSchema={schema.projectName}
                    dataKey={schema.projectName.name}
                    register={register}
                    control={control}
                    errors={errors}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={130}>
            <HeaderCell align="center" style={styleHeaderCell}>
              รหัสโครงการ (ถ้ามี)
            </HeaderCell>
            <Cell>
              {(rowData) => {
                if (!rowData.isDeletable) {
                  return rowData.projectCode
                }
                return (
                  <EditTextCell
                    id={`${schema.projectCode.name}_${rowData.id || rowData.makeId}`}
                    rowData={rowData}
                    rowSchema={schema.projectCode}
                    dataKey={schema.projectCode.name}
                    register={register}
                    control={control}
                    errors={errors}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column align="center" width={190}>
            <HeaderCell align="center" style={styleHeaderCell}>
              วันที่สิ้นสุดโครงการ
            </HeaderCell>
            <Cell>
              {(rowData) => {
                if (!rowData.isDeletable) {
                  return rowData.projectEndDate
                }
                return (
                  <EditDateCell
                    id={`${schema.projectEndDate.name}_${rowData.id || rowData.makeId}`}
                    rowData={rowData}
                    dataKey={schema.projectEndDate.name}
                    register={register}
                    control={control}
                    errors={errors}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={250}>
            <HeaderCell
              align="center"
              style={styleHeaderCell}
            >{`ปริมาณงานที่รับผิดชอบคิดเป็นสัดส่วนร้อยละ`}</HeaderCell>
            {/* <Cell align="right" dataKey="responsiblePercent" /> */}
            <Cell align="right">
              {(rowData) => {
                return (
                  <EditNumberCell
                    id={`${schema.responsiblePercent.name}_${rowData.id || rowData.makeId}`}
                    rowData={rowData}
                    dataKey={schema.responsiblePercent.name}
                    register={register}
                    control={control}
                    errors={errors}
                    isRequired={true}
                    isBudgetFormat={true}
                    styleSheet={{ marginTop: 8, textAlign: 'right' }}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={240} align="center" fixed="right">
            <HeaderCell align="center" style={styleHeaderCell}>
              จัดการ
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    {rowData.isDeletable ? (
                      <>
                        {rowData.status === 'EDIT' ? (
                          <>
                            <IconButton
                              appearance="ghost"
                              icon={<Icon icon="save" className="bt-gost-icon-radius" />}
                              onClick={handleSubmit((data) => handleSaveData(data, rowData))}
                            >
                              บันทึก
                            </IconButton>
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost-cancel"
                              style={{ marginLeft: 5 }}
                              icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
                              onClick={() => handleCancel(rowData)}
                            >
                              ยกเลิก
                            </IconButton>
                          </>
                        ) : (
                          <>
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost-edit"
                              icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                              onClick={() => handleOpenEditRow(rowData)}
                              disabled={rowData.disabled}
                            >
                              แก้ไข
                            </IconButton>
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost-cancel"
                              style={{ marginLeft: 5 }}
                              icon={<Icon icon="trash-o" className="bt-gost-icon-radius-cancel" />}
                              onClick={() => handleDelete(rowData)}
                              disabled={rowData.disabled}
                            >
                              ลบ
                            </IconButton>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {/* <IconButton
                          appearance="ghost"
                          icon={<Icon icon="save" className="bt-gost-icon-radius" />}
                          onClick={handleSubmit((data) => handleSaveData(data, rowData))}
                        >
                          บันทึก
                        </IconButton>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          style={{ marginLeft: 5 }}
                          icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
                          onClick={() => handleCancel(rowData)}
                        >
                          ยกเลิก
                        </IconButton> */}
                        {rowData.status === 'EDIT' ? (
                          <>
                            <IconButton
                              appearance="ghost"
                              icon={<Icon icon="save" className="bt-gost-icon-radius" />}
                              onClick={handleSubmit((data) => handleSaveData(data, rowData))}
                            >
                              บันทึก
                            </IconButton>
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost-cancel"
                              style={{ marginLeft: 5 }}
                              icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
                              onClick={() => handleCancel(rowData)}
                            >
                              ยกเลิก
                            </IconButton>
                          </>
                        ) : (
                          <>
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost-edit"
                              icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                              onClick={() => handleOpenEditRow(rowData)}
                              disabled={rowData.disabled}
                            >
                              แก้ไข
                            </IconButton>
                          </>
                        )}
                      </>
                    )}
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Form>

      <ConfirmWidget
        title={`ยืนยันการลบงวดเงิน`}
        show={isShowConfirmDelete}
        detail={`กรุณายืนยันการลบงวดเงิน`}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleOnConfirmDelete}
      />

      <div>
        <br />
        <IconButton
          appearance="ghost"
          icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
          onClick={handleOnClickAddNewData}
          disabled={disabledButton}
        >
          {'เพิ่มโครงการ'}
        </IconButton>
      </div>
    </>
  )
}
